import { render, staticRenderFns } from "./ChatContents.vue?vue&type=template&id=640377ec&scoped=true"
import script from "./ChatContents.vue?vue&type=script&lang=js"
export * from "./ChatContents.vue?vue&type=script&lang=js"
import style0 from "./ChatContents.vue?vue&type=style&index=0&id=640377ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640377ec",
  null
  
)

export default component.exports